export default __webpack_public_path__ + "static/media/harbor.696ce72e.svg";